import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { SeoHead } from '@/components/SeoHead';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';
import { useTranslation } from '@/i18n/i18n';

const NotFound = () => {
  const routerLocation = useLocation();
  const { pathname } = routerLocation;
  const { t, locale } = useTranslation();
  const localizedPath = useLocalizedPath();

  useEffect(() => {
    console.error('404 Error: User attempted to access non-existent route:', pathname);
  }, [pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <SeoHead>
        <html lang={locale} />
        <meta name="robots" content="noindex, nofollow" />
      </SeoHead>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-semibold">{t('notFound.heading')}</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t('notFound.message')}</p>
        <Link to={localizedPath('/')} className="text-primary underline hover:text-primary/90">
          {t('notFound.backHome')}
        </Link>
        <div className="mt-8 flex flex-col items-center gap-2 text-sm">
          <Link
            to={localizedPath('/jdg')}
            className="underline text-muted-foreground hover:text-foreground"
          >
            {t('doors.jdg.title')}
          </Link>
          <Link
            to={localizedPath('/biura')}
            className="underline text-muted-foreground hover:text-foreground"
          >
            {t('doors.biura.title')}
          </Link>
          <Link
            to={localizedPath('/wdrozenia')}
            className="underline text-muted-foreground hover:text-foreground"
          >
            {t('doors.wdrozenia.title')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
